import { ExpressionEvaluator, ExpressionEvaluatorType } from './interfaces/expression-evaluator';
import { PrimitiveTypes } from '../shared/interfaces/generics';

export class LiteralExpression implements ExpressionEvaluator<null, PrimitiveTypes> {
  value: PrimitiveTypes;

  constructor(value: PrimitiveTypes) {
    this.value = value;
  }

  getType() {
    return ExpressionEvaluatorType.LITERAL;
  }

  evaluate() {
    return this.value;
  }
}
